import { render } from "./StatisticheAgyo.vue?vue&type=template&id=a55f929c&scoped=true"
import script from "./StatisticheAgyo.vue?vue&type=script&lang=js"
export * from "./StatisticheAgyo.vue?vue&type=script&lang=js"

import "./StatisticheAgyo.vue?vue&type=style&index=0&id=a55f929c&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a55f929c"]])

export default __exports__